import { put, takeLatest, call } from 'redux-saga/effects'

import * as orderService from '../../../services/orderService'
import {
  USE_POINT,
  USE_POINT_SUCCESS,
  USE_POINT_ERROR
}
  from '../../actions/order'

function * usePointSaga (action) {
  try {
    const data = yield call(orderService.UsePoint, action.payload)

    yield put({
      type: USE_POINT_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: USE_POINT_ERROR, error: error.data
    })
  }
}

export function * usePointSagaWatcher () {
  yield takeLatest(USE_POINT, usePointSaga)
}
